/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import Skeleton from "./Skeleton";
import SkeletonText from "./SkeletonText";
import Flex from "../ui/Flex";
import Stack from "../ui/Stack";
import BookingStepItem from "../booking/steps/BookingStepItem";

const StyledItem = styled((props) => <BookingStepItem {...props} />)`
  position: relative;
  padding: 12px;

  ${({ theme }) => theme.containerMedia.sm} {
    padding: 8px;
  }
`;

const ItemInner = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  ${({ theme }) => theme.containerMedia.sm} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const SkeletonItemMain = styled(Stack)`
  width: 100%;
`;

const SkeletonImage = styled((props) => <Skeleton {...props} />)`
  flex-shrink: 0;
  width: 6.875rem;
  height: 6.875rem;

  ${({ theme }) => theme.containerMedia.sm} {
    width: 5rem;
    height: 5rem;
  }
`;

const ButtonSkeleton = styled(Skeleton)`
  width: 2.25rem;
  height: 2.25rem;
  margin-top: 2px;
  flex-shrink: 0;

  ${({ theme }) => theme.containerMedia.sm} {
    position: absolute;
    top: 8px;
    right: 8px;
  }
`;

const SkeletonFooter = styled.div`
  padding-bottom: 0.375rem;
`;

const ServiceItemSkeleton = () => {
  return (
    <StyledItem>
      <ItemInner>
        <SkeletonImage borderRadius={8} />
        <SkeletonItemMain>
          <Flex $align="start" $justify="space-between" $gap="1rem">
            <Stack $gap="0.125rem" style={{ width: "100%" }}>
              <SkeletonText size="h3" width="60%" />
              <SkeletonText size="small" lines={2} />
            </Stack>
            <ButtonSkeleton borderRadius="50%" />
          </Flex>
          <SkeletonFooter>
            <SkeletonText width="30%" />
          </SkeletonFooter>
        </SkeletonItemMain>
      </ItemInner>
    </StyledItem>
  );
};

export default ServiceItemSkeleton;
